// provisions-upsell.js
// Simple cart-drawer upsell logic for Provisions/Main carts.
// Triggers once per session after the cart drawer is opened,
// if the cart contains a product that has an upsell mapping.

(function () {
    'use strict';

    // ---------------------------------------------------------------------------
    // Configuration
    // ---------------------------------------------------------------------------

    // Session flag key to avoid nagging.
    var SESSION_FLAG_KEY = 'provisions_upsell_shown';

    // Delay (ms) after "drawer open" signal before checking cart.
    // Gives the theme time to finish any drawer animations / DOM updates.
    var DRAWER_CHECK_DELAY_MS = 0;

    // ---------------------------------------------------------------------------
    // Helper: basic Provisions cart classification (duplicated from guard logic)
    // ---------------------------------------------------------------------------

    // REFACTORED: Uses Line Item Properties instead of Handle Regex
    function classifyCart(cart) {
        var hasShare = false;
        var hasAddon = false;
        var hasMain = false;

        if (!cart || !cart.items || !cart.items.length) {
            return { hasProvisions: false, hasMain: false, isMixed: false, hasShare: false, hasAddon: false };
        }

        for (var i = 0; i < cart.items.length; i++) {
            var item = cart.items[i];
            // Check hidden properties
            var propType = item.properties && item.properties['_provisions_type'];

            if (propType === 'share') {
                hasShare = true;
            } else if (propType === 'addon') {
                hasAddon = true;
            } else {
                // If it doesn't have our stamp, it's a Main item
                hasMain = true;
            }
        }

        var hasProvisions = hasShare || hasAddon;

        return {
            hasProvisions: hasProvisions,
            hasMain: hasMain,
            isMixed: hasProvisions && hasMain,
            hasShare: hasShare,
            hasAddon: hasAddon
        };
    }

    // ---------------------------------------------------------------------------
    // Helper: DOM utilities for modal
    // ---------------------------------------------------------------------------

    function createUpsellOverlay() {
        var overlay = document.createElement('div');
        overlay.className = 'provisions-upsell-overlay';
        return overlay;
    }


    function escapeHtml(str) {
        if (!str) {
            return '';
        }
        return String(str)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    }

    function removeUpsellOverlay(overlay) {
        if (overlay && overlay.parentNode) {
            overlay.parentNode.removeChild(overlay);
        }
    }

    // ---------------------------------------------------------------------------
    // Core: show upsell modal and handle actions
    // ---------------------------------------------------------------------------

    function showUpsellModal(products) {
        if (!products || !products.length) {
            return;
        }

        var overlay = createUpsellOverlay();

        var rowsHtml = products.map(function (product) {
            var title = product && product.title ? product.title : 'Recommended add-on';

            // Generate the link to the product page
            var productUrl = (product && product.handle) ? '/products/' + product.handle : '#';

            var priceText = '';
            if (product && product.variants && product.variants.length) {
                var cents = product.variants[0].price;
                var value = parseFloat(cents);
                if (!isNaN(value)) {
                    priceText = '$' + value.toFixed(2);
                }
            }

            var imageHtml = '';
            if (product && product.images && product.images.length) {
                // Handle both String (Product API) and Object (Collection API) formats
                var firstImage = product.images[0];
                var rawSrc = '';

                if (typeof firstImage === 'string') {
                    rawSrc = firstImage;
                } else if (firstImage && firstImage.src) {
                    rawSrc = firstImage.src;
                }

                // Check for secondary image
                var secondImage = (product.images.length > 1) ? product.images[1] : null;
                var rawSrc2 = '';
                if (secondImage) {
                    if (typeof secondImage === 'string') {
                        rawSrc2 = secondImage;
                    } else if (secondImage && secondImage.src) {
                        rawSrc2 = secondImage.src;
                    }
                }

                if (rawSrc) {
                    var src = rawSrc + (rawSrc.indexOf('?') === -1 ? '?width=600' : '&width=600');

                    var img1 = '<img src="' + encodeURI(src) + '" alt="' + escapeHtml(title) + '" class="upsell-img-primary">';
                    var img2 = '';

                    if (rawSrc2) {
                        var src2 = rawSrc2 + (rawSrc2.indexOf('?') === -1 ? '?width=600' : '&width=600');
                        img2 = '<img src="' + encodeURI(src2) + '" alt="' + escapeHtml(title) + '" class="upsell-img-hover">';
                    }

                    imageHtml =
                        '<div class="provisions-upsell-modal__image">' +
                        '<a href="' + productUrl + '">' +
                        img1 +
                        img2 +
                        '</a>' +
                        '</div>';
                }
            }

            return ''
                + '<div class="provisions-upsell-modal__row" data-upsell-product-id="' + product.id + '">'
                +   (imageHtml || '')
                +   '<div class="provisions-upsell-modal__content">'
                +     '<h2 class="provisions-upsell-modal__title">' +
                '<a href="' + productUrl + '" style="text-decoration: none; color: inherit;">' + escapeHtml(title) + '</a>' +
                '</h2>'
                +     (priceText ? '<div class="provisions-upsell-modal__price">' + priceText + '</div>' : '')
                +     '<div class="provisions-upsell-modal__actions">'
                +       '<button type="button" class="provisions-upsell-modal__btn provisions-upsell-modal__btn--add" '
                + 'data-upsell-variant-id="' + product.variants[0].id + '">Add to cart</button>'
                +     '</div>'
                +   '</div>'
                + '</div>';
        }).join('');

        var sharedDescription = 'While you’re here… want to toss in a little something extra? ' +
            'These add-on boxes are customer favorites and only available with the purchase of a Provisions Share.';

        var modal = document.createElement('div');
        modal.className = 'provisions-upsell-modal';
        modal.innerHTML =
            '<div class="provisions-upsell-modal__inner">' +
            '<button type="button" class="provisions-upsell-modal__close" aria-label="Close upsell">&times;</button>' +
            '<div class="provisions-upsell-modal__intro-copy">' +
            escapeHtml(sharedDescription) +
            '</div>' +
            '<div class="provisions-upsell-modal__rows">' +
            rowsHtml +
            '</div>' +
            '<div class="provisions-upsell-modal__footer-actions">' +
            '<button type="button" class="provisions-upsell-modal__btn provisions-upsell-modal__btn--dismiss-all">' +
            'No thanks' +
            '</button>' +
            '</div>' +
            '</div>';

        overlay.appendChild(modal);
        document.body.appendChild(overlay);

        var closeBtn = modal.querySelector('.provisions-upsell-modal__close');
        var dismissAllBtn = modal.querySelector('.provisions-upsell-modal__btn--dismiss-all');
        var addButtons = modal.querySelectorAll('.provisions-upsell-modal__btn--add');

        function cleanup() {
            removeUpsellOverlay(overlay);
        }

        if (closeBtn) {
            closeBtn.addEventListener('click', cleanup);
        }
        if (dismissAllBtn) {
            dismissAllBtn.addEventListener('click', cleanup);
        }

        addButtons.forEach(function (btn) {
            btn.addEventListener('click', function () {
                var variantId = btn.getAttribute('data-upsell-variant-id');
                addUpsellVariantToCart(variantId, function () {
                    // keep modal open so they can add more if desired
                });
            });
        });

        overlay.addEventListener('click', function (e) {
            if (e.target === overlay) {
                cleanup();
            }
        });
    }

    function addUpsellVariantToCart(variantId, done) {
        if (!variantId) {
            if (typeof done === 'function') done();
            return;
        }

        try {
            var xhr = new XMLHttpRequest();
            xhr.open('POST', '/cart/add.js', true);
            xhr.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            xhr.onreadystatechange = function () {
                if (xhr.readyState !== 4) {
                    return;
                }
                // Optional: Check if request was actually successful before refreshing
                if (xhr.status === 200) {
                    refreshCartDrawer(done);
                } else {
                    console.error('Shopify Cart Error:', xhr.responseText);
                    // Call done() anyway so the UI doesn't hang?
                    if (typeof done === 'function') done();
                }
            };

            // --- THE FIX IS HERE ---
            // Wrapped the object inside an 'items' array
            xhr.send(JSON.stringify({
                items: [{
                    id: variantId,
                    quantity: 1,
                    properties: {
                        '_provisions_type': 'addon'
                    }
                }]
            }));
            // -----------------------

        } catch (e) {
            if (typeof done === 'function') {
                done();
            }
        }
    }

    function refreshCartDrawer(done) {
        var drawerEl = document.querySelector('cart-drawer');
        if (!drawerEl) {
            if (typeof done === 'function') done();
            return;
        }

        // Use Shopify's section rendering API to get updated HTML
        var url = '/cart?sections=cart-drawer,cart-icon-bubble';

        try {
            var xhr = new XMLHttpRequest();
            xhr.open('GET', url, true);
            xhr.onreadystatechange = function () {
                if (xhr.readyState !== 4) {
                    return;
                }

                if (xhr.status !== 200) {
                    if (typeof done === 'function') done();
                    return;
                }

                var data;
                try {
                    data = JSON.parse(xhr.responseText);
                } catch (e) {
                    if (typeof done === 'function') done();
                    return;
                }

                // Build the parsedState object expected by CartDrawer.renderContents
                var parsedState = {
                    id: Date.now(), // not critical for our use, but CartDrawer stores it
                    sections: data
                };

                try {
                    if (typeof drawerEl.renderContents === 'function') {
                        drawerEl.renderContents(parsedState);
                    }
                } catch (e) {
                    // swallow render errors to avoid blocking overlay cleanup
                }

                if (typeof done === 'function') {
                    done();
                }
            };
            xhr.send();
        } catch (e) {
            if (typeof done === 'function') {
                done();
            }
        }
    }

    // ---------------------------------------------------------------------------
    // Flow: determine upsell candidate for current cart
    // ---------------------------------------------------------------------------

    // New Helper: Fetch upsell candidates from a specific collection
    function fetchUpsellCollection(callback) {
        var url = '/collections/provisions-addon-feed/products.json?limit=10';

        try {
            var xhr = new XMLHttpRequest();
            xhr.open('GET', url, true);
            xhr.onreadystatechange = function () {
                if (xhr.readyState !== 4) return;
                if (xhr.status === 200) {
                    try {
                        var data = JSON.parse(xhr.responseText);
                        callback(data.products || []);
                    } catch (e) {
                        callback([]);
                    }
                } else {
                    callback([]);
                }
            };
            xhr.send();
        } catch (e) { callback([]); }
    }

    function getEligibleUpsells(cart, callback) {
        var classInfo = classifyCart(cart);
        console.log('🔍 [Upsell] 0. Cart Classification:', classInfo);

        if (!classInfo.hasProvisions || classInfo.isMixed) {
            console.warn('🔍 [Upsell] ABORT: Cart is not eligible (Mixed or Main-only).');
            callback([]); return;
        }

        var cartHandles = cart.items.map(function (item) { return item.handle; });

        fetchUpsellCollection(function(products) {
            var eligible = products.filter(function(product) {
                return cartHandles.indexOf(product.handle) === -1;
            });
            console.log('🔍 [Upsell] 4. Eligible products (not in cart):', eligible);
            callback(eligible.slice(0, 12));
        });
    }

    function handleDrawerOpenedOnce() {
        // Session throttle: only show once per browser session.
        try {
            if (window.sessionStorage && window.sessionStorage.getItem(SESSION_FLAG_KEY) === '1') {
                return;
            }
        } catch (e) {
            // ignore storage errors
        }

        setTimeout(function () {
            try {
                var xhr = new XMLHttpRequest();
                xhr.open('GET', '/cart.js', true);
                xhr.onreadystatechange = function () {
                    if (xhr.readyState !== 4) {
                        return;
                    }
                    if (xhr.status !== 200) {
                        return;
                    }

                    var cart;
                    try {
                        cart = JSON.parse(xhr.responseText);
                    } catch (e) { return; }

                    // Use the new async helper
                    getEligibleUpsells(cart, function(products) {
                        if (!products || !products.length) {
                            return;
                        }

                        // Mark as shown
                        try {
                            if (window.sessionStorage) {
                                window.sessionStorage.setItem(SESSION_FLAG_KEY, '1');
                            }
                        } catch (e) {}

                        showUpsellModal(products);
                    });
                };
                xhr.send();
            } catch (e) {
                // silent fail
            }
        }, DRAWER_CHECK_DELAY_MS);
    }

    // ---------------------------------------------------------------------------
    // Detect "cart drawer opened"
    // ---------------------------------------------------------------------------

    function initDrawerOpenListener() {
        // Option 1: custom event (keep in case we ever emit this ourselves)
        document.addEventListener('provisions:cart-drawer-open', function () {
            handleDrawerOpenedOnce();
        });

        // Option 2: observe <cart-drawer> element for open/close via class "active"
        var drawerEl = document.querySelector('cart-drawer');
        if (!drawerEl || typeof MutationObserver === 'undefined') {
            return;
        }

        // cart-drawer has class "active" when drawer is open
        var lastOpenState = drawerEl.classList.contains('active');

        var observer = new MutationObserver(function () {
            var isOpen = drawerEl.classList.contains('active');
            if (isOpen && !lastOpenState) {
                // Drawer just transitioned from closed -> open
                handleDrawerOpenedOnce();
            }
            lastOpenState = isOpen;
        });

        observer.observe(drawerEl, { attributes: true, attributeFilter: ['class'] });
    }

    // ---------------------------------------------------------------------------
    // Bootstrap
    // ---------------------------------------------------------------------------

    function initProvisionsUpsell() {
        if (typeof document === 'undefined') {
            return;
        }

        // We no longer check for PROVISIONS_UPSELL_HANDLES here because
        // we fetch from a collection dynamically.

        initDrawerOpenListener();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initProvisionsUpsell);
    } else {
        initProvisionsUpsell();
    }
})();